import React from 'react';
import ReactStars from "react-rating-stars-component";

const StarRating = ({ rating, size }) => {

  return (
    <ReactStars
      count={5}
      value={rating}
      size={size || 24}
      emptyIcon={<i className="far fa-star"></i>}
      halfIcon={<i className="fa fa-star-half-alt"></i>}
      fullIcon={<i className="fa fa-star"></i>}
      activeColor="#ffd700"
      edit={false}
      isHalf={true}
    />
  )
}

export default StarRating
